export const LOAD_COURSES_PROFILE = 'LOAD_COURSES_PROFILE';
export const LOAD_COURSES_PROFILE_SUCCESS = 'LOAD_COURSES_PROFILE_SUCCESS';
export const LOAD_COURSES_PROFILE_FAIL = 'LOAD_COURSES_PROFILE_FAIL';
